// @ts-check

/** @file Adds cross-project Board snapshots and permits transient feed reorder overlap. */

import Migration from "velocious/build/src/database/migration/index.js"

/** Adds cross-project labels and lets authoritative multi-row reorders apply sequentially. */
export default class AddTaskBoardPlacementPresentation extends Migration {
  /** Adds safe presentation fields and removes server-only positional uniqueness. */
  async up() {
    await this.addColumn("task_boards", "board_project_id", "uuid", {null: true})
    await this.addColumn("task_boards", "board_name", "string", {null: true})
    await this.addColumn("task_boards", "board_column_name", "string", {null: true})
    await this.removeIndex("task_boards", ["board_column_id", "row_number"])
  }

  /** Restores the original replica schema. */
  async down() {
    await this.addIndex("task_boards", ["board_column_id", "row_number"], {unique: true})
    await this.removeColumn("task_boards", "board_column_name")
    await this.removeColumn("task_boards", "board_name")
    await this.removeColumn("task_boards", "board_project_id")
  }
}

AddTaskBoardPlacementPresentation.onDatabases(["projectReplica"])
